import { Data, TextComponentConfig } from "../textInterfaces";

import { Option as RadioOption } from "@storeblocks/radio";
import { Option as SelectOption } from "@storeblocks/select";
import { HintProps } from "Components/Form/RadioButton/radioButtonInterfaces";
import { replaceComponentNameLevel2 } from "Components/TextContext";
import { TextManager } from "../TextManager";
import { TextComponentNameLevel2 } from "../textConstants";

export const mapSelectOptions = (
  components: Data[],
  config?: TextComponentConfig,
): SelectOption[] => {
  return components.map((component) => {
    const label = TextManager.getText(component.name, {
      variables: config?.variables,
      variant: config?.variant,
      plurals: config?.plurals,
    });
    const value = replaceComponentNameLevel2(
      component,
      TextComponentNameLevel2.OPTION_VALUE,
    )?.text;

    if (value === undefined) {
      throw new Error(
        `Could not find corresponding optionvalue component [${component.name}]`,
      );
    }
    return {
      label: label,
      value: value,
    };
  });
};

export const mapRadioOptions = (
  components: Data[],
  config?: TextComponentConfig,
  hintProps?: HintProps,
): RadioOption[] => {
  return components.map((component, index) => {
    const label = TextManager.getText(component.name, {
      variables: config?.variables,
      variant: config?.variant,
      plurals: config?.plurals,
    });
    const value = replaceComponentNameLevel2(
      component,
      TextComponentNameLevel2.OPTION_VALUE,
    )?.text;
    const id = replaceComponentNameLevel2(
      component,
      TextComponentNameLevel2.OPTION_ID,
    )?.text;

    if (value === undefined) {
      throw new Error(
        `Could not find corresponding optionvalue component [${component.name}]`,
      );
    }

    return {
      label: label,
      value: value,
      id: id !== undefined ? id : `${component.name}_${index}`,
      hint:
        replaceComponentNameLevel2(
          component,
          TextComponentNameLevel2.OPTION_HINT,
        )?.text ?? undefined,
      disabled:
        replaceComponentNameLevel2(
          component,
          TextComponentNameLevel2.OPTION_DISABLED,
        )?.text === "true"
          ? true
          : false,
      info:
        replaceComponentNameLevel2(
          component,
          TextComponentNameLevel2.OPTION_INFO,
        )?.text ?? undefined,
      hintProps: hintProps ? hintProps : undefined,
    };
  });
};
